import { render } from "./SigninBody.vue?vue&type=template&id=52f60708"
import script from "./SigninBody.vue?vue&type=script&lang=js"
export * from "./SigninBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__